<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        Deposit
    </ng-container>

    <ng-container dialog-process-in-progress>
        <ng-container *ngIf="!paymentMethod; else formContainer">
            <div class="page-body d-flex flex-column">
                <div class="container-fluid">
                    <div class="row">
                        <div
                            appCheckPermissionRule

                            [rule]="data.depositPermissionRule"

                            (click)="selectPaymentMethod(paymentMethods.BankTransfer)"

                            [ngClass]="{
                                'cursor-pointer': (data.linkedAccounts.length > 0) &&
                                    (allowedBankTransferAccountStatuses.indexOf(data.account.accountStatus) >= 0)
                            }"

                            class="col-4 offset-1 text-center item"
                        >
                            <i
                                [ngClass]="{
                                    'text-muted': (data.linkedAccounts.length === 0) ||
                                        (allowedBankTransferAccountStatuses.indexOf(data.account.accountStatus) < 0)
                                }"

                                class="fa fa-3x fa-bank d-block text-primary"
                            ></i>
                            <span class="text">Bank</span>
                        </div>
                        <div
                            *ngIf="visibleTransferButton"
                            (click)="selectPaymentMethod(paymentMethods.InternalTransfer)"
                            [ngClass]="{'cursor-pointer': data.tradingAccounts.length > 1}"
                            class="col-4 offset-1 text-center item"
                        >
                            <i
                                [ngClass]="{'text-muted': [0, 1].indexOf(data.tradingAccounts.length) >= 0}"

                                class="fa fa-3x fa-exchange d-block text-primary"
                            ></i>
                            <span class="text">Internal</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #formContainer>
            <form [formGroup]="depositForm.form" autocomplete="off">
                <div
                    [ngClass]="{
                        'mb-4': accountFrom && (paymentMethod === paymentMethods.InternalTransfer) && (depositForm.controls[0].errors.length > 0),
                        'mb-3': (
                                    !accountFrom &&
                                        (paymentMethod === paymentMethods.InternalTransfer) &&
                                            (depositForm.controls[0].errors.length > 0)
                                ) || (
                                    (paymentMethod === paymentMethods.BankTransfer) &&
                                        (depositForm.controls[0].errors.length > 0)
                                )
                    }"
                >
                    <app-autocomplete
                        [formControlName]="depositForm.controls[0].name"
                        [control]="depositForm.controls[0]"

                        (ngModelChange)="(paymentMethod === paymentMethods.InternalTransfer) && getAccountDetails($event)"
                    ></app-autocomplete>
                </div>

                <div
                    *ngIf="(paymentMethod === paymentMethods.InternalTransfer) && accountFrom"

                    class="row transfer-details-wrapper"
                >
                    <div class="col-lg-10">
                        <div class="card">
                            <div class="card-body">
                                <span class="label">Balance</span>
                                <span class="value">
                                    {{accountFrom.availableCash|formatCurrency:accountFrom.currencyCode}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex justify-content-center">
                        <a
                            (click)="getAccountDetails(accountFrom.accountId)"

                            href="javascript:void(0);"
                            class="cursor-pointer text-primary  d-inline-block pt-lg-3 px-2"
                        >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div>
                    <app-panel-input
                        [formControlName]="depositForm.controls[1].name"
                        [control]="depositForm.controls[1]"
                    ></app-panel-input>
                </div>

                <div class="row transfer-details-wrapper">
                    <div class="col-lg-10">
                        <div class="card">
                            <div class="card-body">
                                <span class="label">Balance</span>
                                <span class="value">
                                    {{data.account.availableCash|formatCurrency:data.account.currencyCode}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto d-flex justify-content-center">
                        <a
                            (click)="getAccountDetails(data.account.accountId, true)"

                            href="javascript:void(0);"
                            class="cursor-pointer text-primary  d-inline-block pt-lg-3 px-2"
                        >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div [ngClass]="{'mb-2': depositForm.controls[2].errors.length > 0}">
                    <app-amount-input
                        [formControlName]="depositForm.controls[2].name"
                        [control]="depositForm.controls[2]"
                    ></app-amount-input>
                </div>
            </form>
        </ng-template>
    </ng-container>
</app-dialog>
